import React, { useRef, useState } from "react";
import { FaFacebookF, FaYoutube } from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";
import { db } from "../firebase.js";
import { collection, addDoc, query, where, serverTimestamp, getDocs} from 'firebase/firestore';
import {  firebase, auth } from "../firebase.js";
import { RecaptchaVerifier } from "firebase/auth";

const Samarthak = () => {
  const [formData, setFormData] = useState({
    supporterName: "",
    dob: "",
    caste: "",
    mobile: "",
    whatsapp: "",
    village: "",
    tehsil: "",
    district: "",
    state: "",
    introducerName: "",
    introducerMobile: "",
    contactPreferences: [],
    gender: "",
  });

  const [verificationId, setVerificationId] = useState("");
  const [verificationCode,setVerificationcode] = useState("");
  const recaptchaRef = useRef(null);
  const [phoneN, setPhonen] = useState("");


  const sendOtp = () => {

    if(recaptchaRef.current){
      recaptchaRef.current.innerHTML = '<div id="recaptcha-container"></div>'
    }
    const verifier = new RecaptchaVerifier(auth,'recaptcha-container',{
      size: 'invisible'
    });
    console.log(phoneN)

    firebase.auth().signInWithPhoneNumber(phoneN,verifier)
    .then(confirmationResult => {
      setVerificationId(confirmationResult.verificationId);
      alert('otp has been sent to your phone')
    })
    .catch(error => {
      console.error('error otp:', error);
    });

  }

  const verifyOtp = () => {
    const credentials = firebase.auth.PhoneAuthProvider.credential(verificationId,verificationCode);
    firebase.auth().signInWithCredential(credentials)
    .then(userCredential => {
      console.log('user logged in:',userCredential.user);
      alert('OTP has been verified')
    })
    .catch(error => {
      console.error('verification error:',error);
    });
  }






  // Handle input changes for form fields
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    if (name === "mobile") {
      setPhonen(value);
    }
  };

  // Handle checkbox changes for contact preferences
  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setFormData((prevData) => ({
        ...prevData,
        contactPreferences: [...prevData.contactPreferences, value],
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        contactPreferences: prevData.contactPreferences.filter(
          (pref) => pref !== value
        ),
      }));
    }
  };

  // Handle gender changes
  const handleGenderChange = (e) => {
    setFormData({ ...formData, gender: e.target.value });
  };


  // Check if mobile number already exists in the database
  const checkMobileExists = async (mobile) => {
    const q = query(collection(db, "persons"), where("mobile", "==", mobile));
    const querySnapshot = await getDocs(q);
    return !querySnapshot.empty; // Returns true if mobile exists
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if mobile number already exists
    const mobileExists = await checkMobileExists(formData.mobile);
    if (mobileExists) {
      alert("यह सदस्य पहले से मौजूद है। कृपया नया व्यक्ति जोड़ें।");
      return; // Stop further execution
    }

    try {
      await addDoc(collection(db, "persons"), {
        ...formData,
        timestamp: serverTimestamp(),
      });
      alert("व्यक्ति सफलतापूर्वक जोड़ा गया!");
      setFormData({
        supporterName: "",
        dob: "",
        caste: "",
        mobile: "",
        whatsapp: "",
        village: "",
        tehsil: "",
        district: "",
        state: "",
        introducerName: "",
        introducerMobile: "",
        contactPreferences: [],
        gender: "",
      });
    } catch (error) {
      console.error("Error adding person: ", error);
      alert(`Error adding person: ${error}`);
    }
  };
  return (
    <div className="bg-pink-100 h-screen flex flex-col justify-between p-4">
      {/* Header */}
      <header className="flex justify-between items-center mb-2">
        <div className="ml-4">
          <h1 className="text-5xl font-extrabold text-red-700">समर्थकों को जोड़ने हेतु जुड़ें</h1>
          <p className="text-2xl font-semibold mt-2">अभियान को सार्थक बनाने हेतु लोगों को प्रेरित करें और जोड़ें</p>
        </div>
        <div className="flex items-center gap-2 bg-black p-2 rounded w-64 lg:w-72">
          <span className="text-white font-extrabold text-lg">FOLLOW US:</span>
          <div className="flex gap-4">
            <a href="https://www.facebook.com/1reservation/" target="_blank" rel="noopener noreferrer">
              <FaFacebookF className="w-6 h-6 text-white hover:text-gray-200 transition duration-200" />
            </a>
            <a href="https://x.com/1fam1reserv" target="_blank" rel="noopener noreferrer">
              <FaXTwitter className="w-6 h-6 text-white hover:text-gray-200 transition duration-200" />
            </a>
            <a href="https://www.youtube.com/@1family1reservation" target="_blank" rel="noopener noreferrer">
              <FaYoutube className="w-6 h-6 text-white hover:text-gray-200 transition duration-200" />
            </a>
          </div>
        </div>
      </header>

      <div className="flex flex-col lg:flex-row gap-4 justify-center items-center flex-grow">
        {/* Join Supporters Form */}
        <div className="bg-white p-4 shadow-lg rounded-lg w-full md:w-1/2 h-full overflow-hidden flex flex-col justify-between text-sm">
          <h2 className="text-xl font-bold mb-2">व्यक्तियों को जोड़ें</h2>
          <form className="space-y-2" onSubmit={handleSubmit}>
            {/* Name and DOB */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div>
                <label className="text-sm text-gray-600">समर्थक का नाम</label>
                <input
                  type="text"
                  name="supporterName"
                  value={formData.supporterName}
                  onChange={handleInputChange}
                  className="w-full border-b border-gray-300 pb-1 mt-1 focus:outline-none"
                  placeholder="Ram Thakur"
                  required
                />
              </div>
              <div>
                <label className="text-sm text-gray-600">Date of Birth</label>
                <input
                  type="date"
                  name="dob"
                  value={formData.dob}
                  onChange={handleInputChange}
                  className="w-full border-b border-gray-300 pb-1 mt-1 focus:outline-none"
                  required
                />
              </div>
            </div>

            {/* Caste and Category */}
            <div className="flex flex-col lg:flex-row justify-between items-end">
              <div className="w-full lg:w-1/2">
                <label className="text-sm text-gray-600">जाति</label>
                <input
                  type="text"
                  name="caste"
                  value={formData.caste}
                  onChange={handleInputChange}
                  className="border-b border-gray-300 pb-1 mt-1 focus:outline-none"
                  placeholder="Rajas"
                />
              </div>
              <div className="flex items-center gap-2 mt-4 lg:mt-0">
                <span className="text-sm text-gray-600">वर्ग</span>
                {["ST", "SC", "OBC", "Gen"].map((category) => (
                  <label key={category} className="flex items-center gap-1">
                    <input
                      type="checkbox"
                      value={category}
                      onChange={handleCheckboxChange}
                      className="form-checkbox"
                    />
                    <span>{category}</span>
                  </label>
                ))}
              </div>
            </div>

            {/* Gender */}
            <div className="flex items-center gap-4">
              <span className="text-sm text-gray-600">लिंग</span>
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  name="gender"
                  value="Male"
                  onChange={handleGenderChange}
                />
                <span>Male</span>
              </label>
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  name="gender"
                  value="Female"
                  onChange={handleGenderChange}
                />
                <span>Female</span>
              </label>
            </div>

            {/* Phone Numbers */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div ref={recaptchaRef}>
                <label className="text-sm text-gray-600">
                  समर्थक का मोब. नं.
                </label>
                <input
                  type="tel"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleInputChange}
                  className="w-full border-b border-gray-300 pb-1 mt-1 focus:outline-none"
                  placeholder="+91 95555-23419"
                  required
                />
              </div>
              <div>
                <label className="text-sm text-gray-600">व्हाट्स अप न.</label>
                <input
                  type="tel"
                  name="whatsapp"
                  value={formData.whatsapp}
                  onChange={handleInputChange}
                  className="w-full border-b border-gray-300 pb-1 mt-1 focus:outline-none"
                  placeholder="Enter 10 digit number.."
                />
              </div>
            </div>

            {/* OTP Input Section */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
              <div>
                <label className="text-sm text-gray-600">OTP</label>
                <input
                  type="text"
                  name="otp"
                  value={verificationCode}
                  onChange={e => setVerificationcode(e.target.value)}
                  className="w-full border-b border-gray-300 pb-1 mt-1 focus:outline-none"
                  placeholder="Enter OTP"
                />
              </div>
              <div className="flex items-center gap-2">
                <label className="flex items-center gap-1">
                  <input
                    type="checkbox"
                    className="form-checkbox"
                    onClick={sendOtp}
                  />
                  <span>Send OTP</span>
                </label>
                <label className="flex items-center gap-1">
                  <input
                    type="checkbox"
                    className="form-checkbox"
                    onClick={verifyOtp}
                  />
                  <span>Verify OTP</span>
                </label>
              </div>
            </div>

            {/* Address Fields */}
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
              {["गाँव", "तहसील", "जिला", "राज्य"].map((label, index) => (
                <div key={index}>
                  <label className="text-sm text-gray-600">{label}</label>
                  <input
                    type="text"
                    name={label}
                    onChange={handleInputChange}
                    className="w-full border-b border-gray-300 pb-1 mt-1 focus:outline-none"
                    placeholder={label}
                  />
                </div>
              ))}
            </div>

            {/* Reference Details */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div>
                <label className="text-sm text-gray-600">
                  परिचय करता का नाम
                </label>
                <input
                  type="text"
                  name="introducerName"
                  value={formData.introducerName}
                  onChange={handleInputChange}
                  className="w-full border-b border-gray-300 pb-1 mt-1 focus:outline-none"
                  placeholder="Shatrughan Ram"
                />
              </div>
              <div>
                <label className="text-sm text-gray-600">
                  परिचय करता का मोबाइल न.
                </label>
                <input
                  type="tel"
                  name="introducerMobile"
                  value={formData.introducerMobile}
                  onChange={handleInputChange}
                  className="w-full border-b border-gray-300 pb-1 mt-1 focus:outline-none"
                  placeholder="Enter 10 digit number"
                />
              </div>
            </div>

            {/* Contact Preferences */}
            <div>
              <h3 className="font-bold text-base mb-2">सहयोग का स्वरूप</h3>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                {[
                  "व्यक्तिगत संपर्क मोबाइल से संपर्क",
                  "जिले में संपर्क करेंगे",
                  "राज्य में संपर्क करेंगे",
                  "युवाओं से संपर्क करेंगे",
                ].map((option, index) => (
                  <label key={index} className="flex items-center gap-1">
                    <input
                      type="checkbox"
                      value={option}
                      onChange={handleCheckboxChange}
                      className="form-checkbox"
                    />
                    <span>{option}</span>
                  </label>
                ))}
              </div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="bg-red-700 text-white w-full py-2 mt-4 rounded text-center"
            >
              <div>Upload</div>
              <div className="text-xs">अपलोड करें</div>
            </button>
          </form>
        </div>

        {/* Contribution Section */}
        <div className="w-full md:w-1/3 h-full overflow-hidden flex flex-col text-sm md:text-base">
          <h2 className="text-xl font-bold mb-2">सहयोग राशि प्राप्त करें</h2>
          <div className="overflow-x-auto">
            <table className="w-full text-left border text-sm">
              <thead>
                <tr>
                  <th className="p-3">#</th>
                  <th className="p-3">व्यक्तियों को जोड़ने की संख्या</th>
                  <th className="p-3">सहयोग राशि*</th>
                </tr>
              </thead>
              <tbody>
              <tr className="bg-white"><td className="p-3">1</td><td className="p-3">100</td><td className="p-3">₹1,000</td></tr>
              <tr className="bg-pink-100"><td className="p-3">2</td><td className="p-3">500</td><td className="p-3">₹5,000</td></tr>
              <tr className="bg-white"><td className="p-3">3</td><td className="p-3">1,000</td><td className="p-3">₹10,000</td></tr>
              <tr className="bg-pink-100"><td className="p-3">4</td><td className="p-3">5,000</td><td className="p-3">₹50,000</td></tr>
              <tr className="bg-white"><td className="p-3">5</td><td className="p-3">10,000</td><td className="p-3">₹1,00,000</td></tr>
              <tr className="bg-pink-100"><td className="p-3">6</td><td className="p-3">25,000</td><td className="p-3">₹2,50,000</td></tr>
              <tr className="bg-white"><td className="p-3">7</td><td className="p-3">50,000</td><td className="p-3">₹5,00,000</td></tr>
              <tr className="bg-pink-100"><td className="p-3">8</td><td className="p-3">1,00,000</td><td className="p-3">₹10,00,000</td></tr>
                {/* Add more rows as needed */}
              </tbody>
            </table>
          </div>
          <p className="text-xs text-gray-500 mt-2">
            ✧ नियम व शर्तों हेतु क्लिक करें{' '}
            <a href="https://drive.google.com/drive/folders/1rxQszR5EC84Iv2ytlp9G7ls9A9hC7BGQ?usp=sharing" className="text-blue-600">
              here
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Samarthak;
